// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603171849/js/" + chunkId + "." + {"44":"865b22b4","225":"16b4305c","481":"1cebe62d","486":"779a0fa4","770":"834478d6"}[chunkId] + ".0.66906250610077.chunk.js";
};